import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  canonicalUrl,
  keywords,
  type = 'website',
  structuredData,
  defaultTitle = 'Personalized Leather Bound Books | Custom Book Binding &amp; Restoration - Rare Biblio',
  defaultDescription = "Transform your favorite books into personalized leather-bound editions with Rare Biblio. Explore our custom binding, restoration, and PDF-to-leather services, and create timeless pieces tailored to your style. Elevate your collection with handcrafted luxury.",
  defaultCanonicalUrl = 'https://rarebiblio.com/',
  additionalMetaTags = []
}) => {
  // Use provided values or fallback to defaults
  const seoTitle = title || defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoCanonicalUrl = canonicalUrl || defaultCanonicalUrl;

  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Rare Biblio",
    "alternateName": "Rare Biblio",
    "url": "https://www.rarebiblio.com/",
    "publisher": {
      "@type": "Organization",
      "name": "Rare Biblio",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.rarebiblio.com/Assets/Icons/logo.jpg"
      }
    },
    "sameAs": [
      "https://www.facebook.com/rarebiblio/",
      "https://www.instagram.com/Rarebiblio/",
      "https://www.linkedin.com/company/Rarebiblio",
      "https://in.pinterest.com/rare_biblio/",
      "https://x.com/Rarebiblio"
    ]
  }

  const seoStructuredData = structuredData || defaultStructuredData;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={keywords || ''} />
      <link href={seoCanonicalUrl} rel="canonical"/>

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={seoCanonicalUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seoCanonicalUrl} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />

      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(seoStructuredData)
        }}
      />

      {/* Additional Meta Tags */}
      {additionalMetaTags.map((tag, index) => (
        <meta key={index} name={tag.name} content={tag.content} />
      ))}
    </Helmet>
  );
};

export default SEO;